import { Theme } from "@remo-co/ui-core/src/types";

export const styles = {
  title: {
    fontWeight: "500 !important",
  },

  container: {
    color: "events.textPrimary",
  },
  add: {
    display: "flex",
  },
  addOn: {
    marginTop: "3px",
  },

  planDetails: {
    marginBottom: "5px",
  },

  addOnChip: {
    color: (theme: Theme) => `${theme.palette.events.textPrimary} !important`,
    padding: "6px 20px",
    height: "30px",
    fontSize: 14,
    backgroundColor: (theme: Theme) =>
      `${theme.palette.events.grayShade1} !important`,
    "& .MuiChip-root": {
      width: "auto",
    },
  },
};
